import { getIdSports } from '../../../common/data/sports';
//import { useAuth } from '../../../context/auth-context';
import { createModel, deleteModel, getModel, updateModel } from '../../../services/api.service';
import { getModel as getModel2 } from '../../../services/api2.service';
import { IGameReturn, IJoinGame, IJoinGameReturn, IListGameReturn } from '../interfaces/game';

/**
 * Get all games
 */
export const getAllGames = async (page: number, limit: number, search: string): Promise<IListGameReturn> => {
    const urlModel = `games?limit=${limit}&page=${page}&search=${search}`;
    const data = await getModel(urlModel);
    return data;
};

/**
 * Get game by sport name
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getGameBySport = async (query): Promise<IGameReturn> => {
    let filter = '';
    const sportId = getIdSports(query.sport);
    if (query) {
        filter = `?sportId=${sportId ? sportId : ''}&formatId=${query.format ? query.format : ''}&startHour=${
            query.startHour ? query.startHour : ''
        }&daysLimit=${query.daysLimit ? query.daysLimit : ''}&regionId=${query.region ? query.region : ''}&countyId=${
            query.commune ? query.commune : ''
        }&date=${query.date ? query.date : ''}`;
    }
    const urlModel = `games${filter}`;
    const data = await getModel2(urlModel);
    return data;
};

/**
 * Get game by ID
 */
export const getGameById = async (id: string, statusUser: boolean): Promise<IGameReturn> => {
    //console.log('antes')
    //const auth = useAuth();
    //console.log('auth', auth)
    if (statusUser) {
        const urlModel = `api/games/${id}`;
        const data = await getModel(urlModel);
        return data;
    } else {
        const urlModel = `games/${id}`;
        const data = await getModel2(urlModel);
        return data;
    }
};

/**
 * Create a join Game
 * @param values Data to create a join Game
 */
export const joinGameAdd = async (values: IJoinGame): Promise<IJoinGameReturn> => {
    const result = await createModel(`games/${values.gameId}/join`)(values);
    return result;
};

/**
 * Create a join Game
 * @param values Data to create a join Game
 */
export const addGuest = async (values: IJoinGame): Promise<IJoinGameReturn> => {
    const result = await updateModel(`games/${values.gameId}/add/guests`)(values);
    return result;
};

/**
 * Create a join Game
 * @param values Data to create a join Game
 */
 export const addGuestNotification = async (values: IJoinGame): Promise<IJoinGameReturn> => {
    const result = await getModel(`games/${values.gameId}/join-notify`);
    return result;
};

/**
 * Create a join Game
 * @param values Data to create a join Game
 */
export const cancelSubcription = async (values: string): Promise<IJoinGameReturn> => {
    const result = await deleteModel(`games/${values}/cancel/subscription`);
    return result;
};
